import { Observable } from 'rxjs';
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNUser } from './cnuser';
import { SNItem } from './snitem';

@RegisterItem()
export class CNDepartment extends SNItem {

    private language = 'fr';

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNDepartment';
    }

    public get name() {
        return this.getProperty('name_' + this.language);
    }

    public set name(name: string) {
        this.setProperty('name_' + this.language, name);
    }

    public addUser(user: CNUser): Observable<CNUser[]> {
        return new Observable(observer => {
            this.addChild(user).subscribe(newuser => {
                this.addChild(newuser, false);
                this.childs('SNItem.SNUser.CNUser', true).subscribe(users => {
                    observer.next(users as CNUser[]);
                });
            });
        });
    }

    public users(): Observable<CNUser[]> {
        return this.childs('SNItem.SNUser.CNUser', true);
    }

    public removeUser(user: CNUser): Observable<CNUser[]> {
        return new Observable(observer => {
            this.removeChild(user).subscribe(removed => {
                this.childs('SNItem.SNUser.CNUser', true).subscribe(users => {
                    observer.next(users as CNUser[]);
                });
            });
        });
    }

    public clone(): any {
        return new CNDepartment();
    }
}
